'use client';

import { FC } from 'react';

import { getRoute } from '@ravago/shared/next-data-access';
import { DynamicPageUrl } from '@ravago/shared/page-data/models/utils';
import { Button } from '@ravago/shared/radiance/components/button/components/Button/Button';
import { ProducerCard } from '@ravago/shared/radiance/components/card/components/ProducerCard/ProducerCard';
import { Grid } from '@ravago/shared/radiance/components/grid/components/Grid/Grid';
import { GridCol } from '@ravago/shared/radiance/components/grid/components/GridCol/GridCol';
import { useTranslations } from '@ravago/shared/translations/client';

import { ProducerSummary } from '../producer-list-functions';

import { ConsumerWrapper } from '../../consumer-wrapper/consumer-wrapper';
import { DynamicPageLink } from '../../dynamic-page-link/dynamic-page-link';
import { MockLink } from '../../mock-link/mock-link';

interface Props {
   showAllBrandsButton: boolean;
   locale: string;
   isConsumer: boolean;
   productsOverviewRoute: DynamicPageUrl | null;
   producers: ProducerSummary[];
   urlQuery?: string;
   useV2?: boolean;
}

/* c8 ignore start */
export const ProducerList: FC<Props> = ({ showAllBrandsButton, locale, isConsumer, productsOverviewRoute, producers, urlQuery, useV2 }) => {
   const translate = useTranslations();

   return (
      <Grid useContainerQuery={!isConsumer}>
         {producers.map((producer) => (
            <GridCol key={producer.id} useContainerQuery={!isConsumer} spanDesktop={3} spanTablet={6} spanPhone={4}>
               <ProducerCard
                  href={getRoute(
                     locale,
                     productsOverviewRoute?.url,
                     useV2 ? `?tab=brands&producer=${producer.id}` : `?tab=brands&producers=${producer.name}`,
                     undefined
                  )}
                  target="_self"
                  logo={producer.logo}
                  name={producer.name}
               />
            </GridCol>
         ))}
         {showAllBrandsButton && (
            <GridCol useContainerQuery={!isConsumer} spanDesktop={12} spanTablet={12} spanPhone={4}>
               <ConsumerWrapper
                  isConsumer={isConsumer}
                  renderConsumer={(children) => (
                     <DynamicPageLink
                        id={`dynamic-link__producer-list__brands__${urlQuery}`}
                        underline="none"
                        slug={`?tab=brands${urlQuery}`}
                        baseRoute={productsOverviewRoute ?? null}
                        locale={locale}
                     >
                        {children}
                     </DynamicPageLink>
                  )}
                  renderProducer={(children) => <MockLink underline="none">{children}</MockLink>}
               >
                  <Button variant="tertiary" trailingIcon="long-arrow-right" fullWidth>
                     {translate('related-brands-2.all-brands')}
                  </Button>
               </ConsumerWrapper>
            </GridCol>
         )}
      </Grid>
   );
};
/* c8 ignore end */
